/* @flow */
import React from 'react';

class YouTubeEmbed extends React.Component {
  props: {
    width: number,
    height: number,
    src: string,
    className?: string,
  }

  render() {
    const { className, width, height, src } = this.props;
    return (
      <iframe
        className={className}
        width={width}
        height={height}
        src={src + '?rel=0&wmode=transparent'} // Fix for z-index in IE
        frameBorder="0"
        allowFullScreen
      />
    );
  }
}

export default YouTubeEmbed;



// WEBPACK FOOTER //
// ./src/components/YouTubeEmbed.jsx